import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Button, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';

export const StyledHeader = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  gap: theme.spacing(3),

  [theme.breakpoints.up('sm')]: {
    padding: 0,
    flexDirection: 'row',
  },

  [theme.breakpoints.up('md')]: {
    justifyContent: 'space-between',
  },
}));

export const StyledHeaderMain = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  flexGrow: 1,

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(4),
  },

  [theme.breakpoints.up('md')]: {
    justifyContent: 'space-between',
  },
}));

export const StyledHeaderContent = styled(Stack)(({ theme }) => ({
  flexGrow: 1,
  gap: theme.spacing(3),

  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(2),
  },
}));

export const StyledScriptRow = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  alignItems: 'flex-start',

  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(2),
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const StyledIconContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  justifyContent: 'center',
  alignItems: 'center',
  width: theme.spacing(15),
  height: theme.spacing(15),
  borderRadius: theme.spacing(2),
  backgroundColor: outOfBandThemeColors.uMeds.warmWhite,

  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));

export const StyledMetaRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  columnGap: theme.spacing(2.5),
  flexWrap: 'wrap',
}));

export const StyledExpiryRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  color: 'inherit',
}));

export const StyledTreatmentButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,

  [theme.breakpoints.up('lg')]: {
    alignSelf: 'center',
  },
}));
